import axios from 'axios';
import router from "../../router";

const state = {
    showAgeVerification: false,
    settings: [],
    navigation: [],
    clubNav: [],
    footerSubscribeMessage: null
};

const getters = {
    getShowAgeVerification: () => state.showAgeVerification,
    getSettings: () => state.settings,
    getNavigation: () => state.navigation,
    getClubNav: () => state.clubNav,
    getFooterSubscribeMessage: () => state.footerSubscribeMessage
};

const actions = {
    /**
     * fetch all global settings
     * @param commit
     * @returns {Promise<void>}
     */
    async fetchSettings({commit}) {
        const response = await axios.get(window.location.origin + '/settings/all');
        if (typeof response.data !== 'undefined') {
            commit('updateSettings', response.data);
        }
    },

    async fetchNavigationItems({commit}) {
        const response = await axios.get(window.location.origin + '/settings/navigationItems');
        if (typeof response.data !== 'undefined') {
            commit('updateNavigation', response.data.Main);
            commit('updateClubNav', response.data.Club);
        }
    },

    async checkAgeVerification({commit}) {
        const response = await axios.get(window.location.origin + '/settings/ageVerified');
        if (typeof response.data.Verified !== 'undefined') {
            if (!response.data.Verified) {
                commit('updateShowAgeVerification', true);
            }
        }
    },

    async verifyAge({commit}) {
        commit('updateShowAgeVerification', false);
        await axios.get(window.location.origin + '/settings/verifyAge');
    },

    async markNoticeAsClosed({commit}, noticeID) {
        await axios.get(window.location.origin + '/settings/closeNotice/' + noticeID);
        let settings = state.settings,
            remaining = settings.Notices.filter((notice) => {
                return notice.ID !== noticeID;
            });
        settings.Notices = remaining;
        commit('updateSettings', settings);
    },

    async createSubscriber({commit}, data){
        commit('updateFooterSubscribeMessage', null);
        const response = await axios.post(window.location.origin + '/settings/subscribe', data, {headers: {'X-Requested-With': 'XMLHttpRequest'}});
        if (response.data.Status === 200) {
            commit('updateFooterSubscribeMessage', 'Thank you for subscribing');
        }
    }
};

const mutations = {
    updateShowAgeVerification: (state, value) => (state.showAgeVerification = value),
    updateSettings: (state, value) => (state.settings = value),
    updateNavigation: (state, value) => (state.navigation = value),
    updateClubNav: (state, value) => (state.clubNav = value),
    updateFooterSubscribeMessage: (state, value) => (state.footerSubscribeMessage = value)
};

export default {
    state,
    getters,
    actions,
    mutations
};
